// welcome.module.ts
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WelcomeComponent} from './welcome.component';
import {WelcomeRoutingModule} from './welcome-routing.module';
import {HeaderComponent} from './header/header.component';
import {CategoryComponent} from './category/category.component';
import {MenusComponent} from './menus/menus.component';
import {PromosComponent} from './promos/promos.component';

import {RouterModule} from '@angular/router';
import {DetailsMenusComponent} from './menus/details-menus/details-menus.component';
import {
  DetailsProductMenusComponent
} from './menus/details-menus/details-product-menus/details-product-menus.component';
import {DetailsPromosComponent} from './promos/details-promos/details-promos.component';
import {SmartTapDirective} from '../directives/smart-tap.directive';

@NgModule({
  imports: [CommonModule, WelcomeRoutingModule,
    RouterModule,
    SmartTapDirective, WelcomeComponent, HeaderComponent, CategoryComponent, MenusComponent, PromosComponent, DetailsMenusComponent, DetailsProductMenusComponent, DetailsPromosComponent],
})
export class WelcomeModule {
}
